import React from "react";

const ProcessingStatus = ({ status }) => {
  return (
    <div>
      <p>Status: {status}</p>
    </div>
  );
};

export default ProcessingStatus;
